// NOTE: Below capabilities are not present in TMS, thus guarding routes to access by ELMO ADMINS only
// eslint-disable-next-line no-shadow
export enum AdminPermissions {
  MANAGE_FAQ = 'admin.coursebuilder.faq.manage',
  MANAGE_HELP_CONTENT = 'admin.coursebuilder.help.content.manage',
  MANAGE_TAGS = 'admin.coursebuilder.tags.manage',
  MANAGE_TEMPLATE = 'admin.coursebuilder.template.manage',
  MANAGE_THEME = 'admin.coursebuilder.theme.manage',
  MANAGE_TENANT = 'admin.coursebuilder.tenant.manage',
  MANAGE_COMMENTS_MIGRATION = 'admin.coursebuilder.comments.migration.manage',
  MANAGE_CHOICES_MIGRATION = 'admin.coursebuilder.choices.migration.manage',
  MANAGE_ASSESSMENT_TRACKING = 'admin.coursebuilder.assessment.tracking.manage',
}
